import { render, staticRenderFns } from "./runtimeMarkers.vue?vue&type=template&id=45d5f898"
import script from "./runtimeMarkers.vue?vue&type=script&lang=js"
export * from "./runtimeMarkers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports